import React from'react';

const n=v=>v==null||v===''||!Number.isFinite(Number(v))?null:Number(v);
const pct=v=>n(v)==null?'—':Number(v).toFixed(1)+'%';
const ratio=v=>n(v)==null?'—':Number(v).toFixed(2)+'x';
const label=v=>String(v||'MISSING').replaceAll('_',' ');
const tone=v=>String(v||'missing').toLowerCase().replaceAll('_','-');

export default function MoatEvidencePanel({evidence}){
 const e=evidence||{};
 const pillars=[
  ['Economics',e.economics,pct(e.grossMarginPct)+' gross · '+pct(e.operatingMarginPct)+' op'],
  ['Cash conversion',e.cashConversion,ratio(e.cashConversionRatio)],
  ['Customer evidence',e.customerEvidence,(e.validatedDemandRows??0)+' validated / '+(e.verifiedDemandRows??0)+' verified'],
  ['Ecosystem evidence',e.ecosystemEvidence,(e.verifiedRelationshipRows??0)+' verified relationships']
 ];
 return <section className={'moat-panel moat-'+tone(e.state)}><div className="section-head compact"><div><small>MOAT EVIDENCE</small><h2>{label(e.state)}</h2></div><span>{e.status||'MISSING'} · no wide/narrow label</span></div><div className="moat-grid">{pillars.map(([k,v,d])=><div key={k} className={'moat-cell moat-cell-'+tone(v)}><small>{k}</small><b>{label(v)}</b><span>{d}</span></div>)}</div><p>{e.note||'Moat evidence is unavailable.'}</p></section>;
}
